import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { PwaInstaller } from "./lib/installprompt";
import * as serviceWorker from './serviceWorker';

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDgeB-u0DUI9QFj-ZDUr2vOLW3eaVUIBRk",
  authDomain: "augenstern-schmuck.firebaseapp.com",
  databaseURL: "https://augenstern-schmuck.firebaseio.com",
  projectId: "augenstern-schmuck",
  storageBucket: "augenstern-schmuck.appspot.com",
  messagingSenderId: "306918481442",
  appId: "1:306918481442:web:6403ea81d182425a79747b",
  measurementId: "G-LJ52Y2VEYE"
};

if (window.matchMedia('(display-mode: standalone)').matches) {
  PwaInstaller.IsInstalled = true;
}

window.addEventListener("beforeinstallprompt", function (beforeInstallPromptEvent) {
  beforeInstallPromptEvent.preventDefault(); // Prevents immediate prompt display
  PwaInstaller.setexecuteDeferredPrompt(beforeInstallPromptEvent);
});

function isStandalone() {
  return !!navigator.standalone || window.matchMedia('(display-mode: standalone)').matches;
}

function exitsOnBack() {
  //return isStandalone() && browserInfo.os.name === 'Android';
  return isStandalone();
}

if (exitsOnBack()) {
  handleBackEvents();
}

function handleBackEvents() {
  window.history.pushState({}, '');

  window.addEventListener('popstate', () => {
    setTimeout(() => {
      window.history.pushState({}, '');
    }, 2000);
  });
}

serviceWorker.unregister();

serviceWorker.register('/firebase-messaging-sw.js');

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

